import { isCountryColombia } from 'constants/regions';
import { FORMAT_TYPE_MOVEMENT_AUTHORIZATION } from '@constants/transactions';

const selectTypeLastMovements = [
  {
    id: null,
    name: 'Todos los movimientos',
  },
  {
    id: FORMAT_TYPE_MOVEMENT_AUTHORIZATION.INGRESO,
    name: isCountryColombia ? 'Entrada' : 'Ingresos',
  },
  {
    id: FORMAT_TYPE_MOVEMENT_AUTHORIZATION.EGRESO,
    name: isCountryColombia ? 'Salida' : 'Egresos',
  },
];

export default selectTypeLastMovements;
